export enum RegistrationSteps {
  LOADING,
  OFFER,
  OFFER_DISPLAY,
  REJECT,
  ACCEPT,
  CONTRACT,
  PRIVACY_POLICY,
  FINISHING_PROCESS,
  NOT_APPLICABLE,
  OFFER_EXPIRED,
  GENERIC_ERROR,
  CARD_INTRO,
}
